"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphQLClient = exports.getSublessAPIClient = void 0;
var graphql_request_1 = require("graphql-request");
var Cookies = __importStar(require("js-cookie"));
var magic_link_1 = require("../magic-link");
var sublessGraphQLClient;
var getSublessAPIClient = function () {
    var _a;
    if (sublessGraphQLClient)
        return sublessGraphQLClient;
    var query = new URLSearchParams(window.location.search);
    var rhash = query.get('rhash');
    var customerHash = rhash || ((_a = window.customer) === null || _a === void 0 ? void 0 : _a.rechargeHash) || '';
    var domain = process.env.PERMANENT_DOMAIN || window.permanentDomain || '';
    var llaShop = 'hbus';
    if (domain.startsWith('hbca-launched'))
        llaShop = 'hbca';
    else if (domain.startsWith('tiller-and-hatch'))
        llaShop = 'th';
    else if (domain.includes('test'))
        llaShop = 'hbtest';
    var headers = {
        'X-lla-shop': llaShop,
        'x-api-key': process.env.SUBLESS_API_KEY || 'dev-api-key',
        'X-lla-rhash': customerHash,
    };
    var sublessJwtCookie = Cookies.get(magic_link_1.SUBLESS_JWT_COOKIE_NAME);
    if (sublessJwtCookie) {
        try {
            headers.Authorization = JSON.parse(sublessJwtCookie).jwt;
        }
        catch (error) {
            console.error("Failed to add authorization header", error);
        }
    }
    var url = process.env.SUBLESS_API_URI || 'http://localhost:3300/graphql';
    sublessGraphQLClient = new graphql_request_1.GraphQLClient(url, { headers: headers });
    return sublessGraphQLClient;
};
exports.getSublessAPIClient = getSublessAPIClient;
exports.graphQLClient = (0, exports.getSublessAPIClient)();
